module.exports = __webpack_public_path__ + "media/images/business/illust-case-05-2ec274b47e8f167ea676791d3c0d272a.svg";